var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66675 2.66668H11.0001C11.3537 2.66668 11.6928 2.80715 11.9429 3.0572C12.1929 3.30725 12.3334 3.64639 12.3334 4.00001V13.3333C12.3334 13.687 12.1929 14.0261 11.9429 14.2762C11.6928 14.5262 11.3537 14.6667 11.0001 14.6667H3.00008C2.64646 14.6667 2.30732 14.5262 2.05727 14.2762C1.80722 14.0261 1.66675 13.687 1.66675 13.3333V4.00001C1.66675 3.64639 1.80722 3.30725 2.05727 3.0572C2.30732 2.80715 2.64646 2.66668 3.00008 2.66668H4.33341M5.00008 1.33334H9.00008C9.36827 1.33334 9.66675 1.63182 9.66675 2.00001V3.33334C9.66675 3.70153 9.36827 4.00001 9.00008 4.00001H5.00008C4.63189 4.00001 4.33341 3.70153 4.33341 3.33334V2.00001C4.33341 1.63182 4.63189 1.33334 5.00008 1.33334Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.58b15c19042897a9939c6f17221987f9.svg";
export { ForwardRef as ReactComponent };